// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pointer[data-v-30407420]{cursor:pointer}.add-img-card[data-v-30407420]{opacity:.7;border-radius:.5em}.add-img-card[data-v-30407420]:hover{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
